// extracted by mini-css-extract-plugin
module.exports = {"sectionLabel":"styles_sectionLabel__13LVo","wrapper":"styles_wrapper__3fOil","searchBody":"styles_searchBody__3059n","searchCenter":"styles_searchCenter__38Lb8"};